<!-- 视频小程序-注册用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- <div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">视频小程序-注册用户</div> -->
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">注册日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">用户ID</div>
				<a-input v-model="r_userId" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>

			<div class="screen-box">
				<div class="screen-label">用户openid</div>
				<a-input v-model="r_openid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">渠道内容</div>
				<a-select
					mode="multiple"
					style="width: 240px"
					placeholder="请选择渠道内容"
					@change="handleChangeNR"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option  value="3">短剧</a-select-option>
					<a-select-option  value="4">小说小程序</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">小程序渠道</div>
				<a-select
					mode="multiple"
					style="min-width: 220px;max-width: 450px;"
					placeholder="请选择小程序渠道"
					@change="handleChangeV"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">小程序</div>
				
				<xcxSearchSelect ref="getXcxSelect" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_user_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">IP</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeP"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">巨量</a-select-option>
					<a-select-option value="5">腾讯</a-select-option>
					<a-select-option value="6">百度</a-select-option>
					<a-select-option value="7">快手</a-select-option>
					<a-select-option value="8">微博</a-select-option>
					<a-select-option value="2">OPPO</a-select-option>
					<a-select-option value="3">VIVO</a-select-option>
					<a-select-option value="4">华为</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广计划ID</div>
				<a-input v-model="r_plan_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广创意ID</div>
				<a-input v-model="r_creativeid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0项目ID</div>
				<a-input v-model="r_marketing_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">巨量2.0广告ID</div>
				<a-input v-model="r_marketing_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeC" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index " class="table-th-cell"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index  && z_tem.type != 'province' && z_tem.type != 'userAgent' && z_tem.type != 'is_add_desktop' && z_tem.type != 'marketing_click_id'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- IP地址 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'province'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}} {{item.county}}
				</div>
				<!-- 是否匹配到计划 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'marketing_click_id'"  class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{(item.hasOwnProperty('marketing_click_id') && item.marketing_click_id != 0)? '是':'否'}}
				</div>
				<!-- UA -->
				<div  v-if="z_ndex > sticky_index  && z_tem.type == 'userAgent'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					<a-popover v-if="item.userAgent" placement="top">
						<template slot="content">
						  <p style="width: 430px;">{{item.userAgent}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item.userAgent}}
						</div>
					</a-popover>
				</div>
				<!-- 是否加桌 -->
				<div v-if="z_ndex > sticky_index  && z_tem.type == 'is_add_desktop'"  class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.is_add_desktop == 1 ? '是' : '否'}}
				</div>
			</template>
			
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, videoXcxRegisterList,  orderGzhCustomReport, regGzhReport, selectXsVdApplets } from '@/request/api'
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
export default {
	name: 'registerXcx_',
	components: {
		xcxSearchSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterData: { // 搜索条件内容
				vd_channel: {},
				mp_book_channel: {},
			}, 
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道", width:120, type:"plat_channel", },
				{title:"小程序", width:120, type:"applets_name", },
				{title:"注册时间", width:150, type:"register_time", },
				
				{title:"用户Id", width:100, type:"user_id", },
				{title:"用户openid", width:160, type:"openid", },
				{title:"推广链接ID", width:100, type:"user_link_id", },
				{title:"IP", width:150, type:"ip", },
				{title:"IP地址", width:130, type:"province", },
				{title:"UA", width:180, type:"userAgent", },
				
				{title:"推广平台", width:100, type:"channel_name", sort_status:0, sort_control: false, },
				// {title:"是否匹配", width:90, type:"marketing_click_id", sort_status:0, sort_control: false, },
				{title:"匹配指标", width:130, type:"match_type", sort_status:0, sort_control: false, show_control: true, },
				{title:"推广计划ID", width:150, type:"adid", sort_status:0, sort_control: false, },
				{title:"推广创意ID", width:150, type:"creativeid", sort_status:0, sort_control: false, },
				{title:"巨量2.0项目ID", width:170, type:"marketing_project_id", sort_status:0, sort_control: false, },
				{title:"巨量2.0广告ID", width:170, type:"marketing_promotion_id", sort_status:0, sort_control: false, },
				
				{title:"是否回传", width:100, type:"is_report_active", },
				{title:"回传原因", width:120, type:"not_report_active_reason", },
				{title:"回传时间", width:190, type:"report_active_time", },
			],
			sticky_index: 1,
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_userId: null, // 用户ID
			r_openid: null,
			r_user_link_id: null, // 推广链接ID
			r_ip: null, // IP
			r_is_report_pay: undefined, // 是否回传。1为是。0为否
			r_is_match_ad: undefined, // 是否匹配点击。1为是。0为否
			
			r_channel_id: undefined, // 推广平台
						
			r_plan_id: null, // 计划ID
			r_creativeid: null, // 创意ID
			r_marketing_project_id: null, // 项目ID
			r_marketing_promotion_id: null, // 广告ID
			
			r_content_type: undefined, // 渠道内容
			r_vd_qd: [], // 小程序渠道
			r_appid: [], // 小程序
			
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
			
			let f_select = res.data.data.filter
			that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
		})
		
		
		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()
		
		// 搜索
		that.searchButton()

	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},

		handleChangeC(e){ // 是否回传激活
			console.log(e);
			this.r_is_report_pay = e
		},
		handleChangeE(e){ // 是否匹配点击
			console.log(e);
			this.r_is_match_ad = e
		},
		
		// 选择推广平台
		handleChangeP(e){
			this.r_channel_id = e
		},
		
		// 渠道内容
		handleChangeNR(e){
			this.r_content_type = e
		},
		// 小程序渠道
		handleChangeV(e){
			this.r_vd_qd = e
			// 获取小程序下拉
			this.$refs.getXcxSelect.getSelectData(e)
		},
		// 小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				
				userId: that.r_userId, // 用户ID
				openid: that.r_openid,
				user_link_id: that.r_user_link_id, // 推广链接ID
				ip: that.r_ip, // IP
				
				plan_id: that.r_plan_id, // 计划ID
				is_report_active: that.r_is_report_pay, // 是否回传激活。1为是。0为否
				is_match_ad: that.r_is_match_ad, // 是否匹配点击
				
				channel_id: that.r_channel_id, // 推广平台
				
				creativeid: that.r_creativeid, // 创意ID
				marketing_project_id: that.r_marketing_project_id, // 项目ID
				marketing_promotion_id: that.r_marketing_promotion_id, // 广告ID
				
				content_type: that.r_content_type, // 渠道内容
				appid: that.r_appid, // 小程序
				
				plat_channel: that.r_vd_qd, // 小程序渠道
			}
			
			videoXcxRegisterList(r_data).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
	},
	
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>